import axios from "axios";
import { format } from "date-fns";
import { format as dateFormatWithTimeZone } from "date-fns-tz";
import { toPng } from "html-to-image";
import { useState, useEffect } from "react";
import { useRef } from "react";
import { useMemo } from "react";
import { Modal } from "react-bootstrap";
import {
  BsChevronLeft,
  BsExclamationTriangle,
  BsExclamationTriangleFill,
  BsZoomIn,
} from "react-icons/bs";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import handleApiError from "../../helpers/handleApiError";
import { isClient } from "../../services/accountService";
import {
  getAdditionalParcelTracking,
  getNotScannedStatus,
  getOrderComments,
  getOrderDetails,
  getParcelTracking,
} from "../../services/deliveryService";
import { FullPageParcelImageModal } from "../Utility/FullPageParcelImageModal";
import SimpleFadeIn from "../Utility/SimpleFadeIn";
import { mergeWith } from "lodash";
import {
  deliveryExceptions,
  orderStatuses,
  statusFilterMap,
} from "../../constants";
import {
  scanWasMadeForIncorrectInvoiceAndAddress,
  svgStringToBase64,
  filterPODImages,
} from "../../helpers/utilities";

const displayParcelDateAndTime = (parcelObject) => {
  return parcelObject.lastScannedWhen
    ? parcelObject.lastScannedWhen.formattedDate +
        " " +
        parcelObject.lastScannedWhen.formattedTime +
        " " +
        parcelObject.lastScannedWhen.timeZone
    : "N/A";
};

const displayCityAndState = (city, state) => {
  if (city && state) {
    return city + ", " + state;
  } else if (city) {
    return city;
  } else if (state) {
    return state;
  } else return "N/A";
};

// const CxtParcelTable = ({ cxtParcels }) => {
//   //   console.log(cxtParcels);
//   return (
//     <div className="table-responsive">
//       <table className="table order-details-panel-table">
//         <thead>
//           <tr>
//             <th>Parcel Id</th>
//             <th>Barcode</th>
//             <th>Receive Scan</th>
//             <th>Pickup Scan</th>
//             <th>Delivery Scan</th>
//             <th>Last Scan</th>
//             <th>O/S</th>
//           </tr>
//         </thead>
//         <tbody>
//           {(cxtParcels.length > 0 ? cxtParcels : [{}]).map((parcel) => {
//             return (
//               <tr key={parcel.parcelId}>
//                 <td>{parcel.parcelId ? parcel.parcelId : "N/A"}</td>
//                 <td>{parcel.barcode ? parcel.barcode : "N/A"}</td>
//                 <td>
//                   {parcel.orderedDateTime
//                     ? dateFormatWithTimeZone(
//                         new Date(parcel.orderedDateTime),
//                         "MM/dd/yyyy hh:mm a zzz"
//                       )
//                     : "N/A"}
//                 </td>
//                 <td>
//                   {parcel.pickedUpScanDateTime
//                     ? dateFormatWithTimeZone(
//                         new Date(parcel.pickedUpScanDateTime),
//                         "MM/dd/yyyy hh:mm a zzz"
//                       )
//                     : "N/A"}
//                 </td>
//                 <td>
//                   {parcel.deliveryScanDateTime
//                     ? dateFormatWithTimeZone(
//                         new Date(parcel.deliveryScanDateTime),
//                         "MM/dd/yyyy hh:mm a zzz"
//                       )
//                     : "N/A"}
//                 </td>
//                 <td>to do</td>
//                 <td>
//                   {parcel.hasOwnProperty("deliveryScanDateTime") // since we show "Short" when the delivery scan date time is null, i'm checking to see if the key even exists to determine if we didn't have any data at all to begin with.
//                     ? parcel.deliveryScanDateTime
//                       ? "Normal"
//                       : "Short"
//                     : "N/A"}
//                 </td>
//               </tr>
//             );
//           })}
//         </tbody>
//       </table>
//     </div>
//   );
// };
const CxtParcelTable2 = ({
  cxtParcels,
  parcelTrackingHistory,
  selectedParcel,
  handleSelectParcel,
  mainOrderInformation,
  cxtIntendedDestination,
  deliveryId,
  originalInvoiceNumber,
  barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoiceMap,
}) => {
  // console.log(parcelTrackingHistory);
  //   console.log(cxtParcels);

  // const [selectedRow, setSelectedRow] = useState("none");

  // const handleParcelRowClick = (e) => {
  //   // console.log(e);
  //   // console.log(e.target);
  //   // console.log(e.currentTarget.dataset.parcelId);
  //   // console.log(e.target.parentNode);
  //   // alert(
  //   //   e.currentTarget.dataset.parcelId + " " + e.currentTarget.dataset.barcode
  //   // );
  //   if (cxtParcels.length > 0) {
  //     setSelectedRow(e.currentTarget.dataset.barcode);
  //   }
  // };

  //using reduce to group history information by barcode

  // const parcelTrackingObject = useMemo(() => {
  //   let parcelTrackingObjectBuilder = parcelTrackingHistory.reduce(
  //     (rollingObject, currentElement) => {
  //       // console.log("rolling object");
  //       // console.log(rollingObject);
  //       // console.log(currentElement);
  //       //if there is a history for the current element's barcode, grab it so we can add to it. if not, initialize it.
  //       const currentHistoryForBarcode =
  //         rollingObject[currentElement.barcode] || [];
  //       //add current element to history for its barcode
  //       currentHistoryForBarcode.push(currentElement);
  //       //add updated history to the grouping object and return.
  //       rollingObject[currentElement.barcode] = currentHistoryForBarcode;
  //       return rollingObject;
  //     },
  //     {}
  //   );

  //   // console.log("print keys");
  //   for (const property in parcelTrackingObjectBuilder) {
  //     console.log(property);
  //     parcelTrackingObjectBuilder[property].sort((a, b) => {
  //       //sorting by timestamp
  //       //if there are nulls, keep them in the beginning
  //       if (
  //         a.lastScannedWhen === null ||
  //         a.lastScannedWhen.timeStamp === null
  //       ) {
  //         return 1;
  //       }
  //       if (
  //         b.lastScannedWhen === null ||
  //         b.lastScannedWhen.timeStamp === null
  //       ) {
  //         return -1;
  //       }

  //       return b.lastScannedWhen.timeStamp - a.lastScannedWhen.timeStamp;
  //     });
  //   }

  //   return parcelTrackingObjectBuilder;
  // }, [parcelTrackingHistory]);

  // console.log("parcel tracking object");
  // console.log(parcelTrackingObject);

  // parcelTrackingHistory
  // ?.filter((trackingItem) => {
  //   return trackingItem.barcode === parcel.barcode;
  // })
  // .sort((a, b) => {
  //   //sorting by timestamp
  //   //if there are nulls, keep them in the beginning
  //   if (
  //     a.lastScannedWhen === null ||
  //     a.lastScannedWhen.timeStamp === null
  //   ) {
  //     return 1;
  //   }
  //   if (
  //     b.lastScannedWhen === null ||
  //     b.lastScannedWhen.timeStamp === null
  //   ) {
  //     return -1;
  //   }

  //   return (
  //     b.lastScannedWhen.timeStamp -
  //     a.lastScannedWhen.timeStamp
  //   );
  // })[0]?.lastScannedWhen?.formattedDate

  //Maybe make a final table data array with just the information we would display?
  //this would make it easier to add sort buttons, as we would be working with the final data that does not need to be processed or filtered any more
  // const tableData = useMemo(() => {
  //   let tableArray = []
  //   for(let i=0; i<cxtParcels.length;i ++){
  //     tableArray.push({
  //       barcode:"",
  //       lastScan:"",
  //       lastLocation:"",
  //       status:""
  //     })
  //   }
  // }, []);

  const separateOverages = false;
  let mainBarcodes = [];
  let possibleOverages = [];
  if (separateOverages) {
    for (let i = 0; i < cxtParcels.length; i++) {
      if (cxtParcels[i].barcode.startsWith(deliveryId)) {
        mainBarcodes.push(cxtParcels[i]);
      } else {
        possibleOverages.push(cxtParcels[i]);
      }
    }
  } else {
    mainBarcodes = cxtParcels;
  }

  const calculateDeliveredOrderStatusDisplay = (parcel) => {
    //this function is only to be called when the order is considered one of the delivered statuses to determine which one.
    //Previous logic:
    // parcelTrackingHistory[
    //   parcel.barcode
    // ]?.[0]?.reference1?.trim() !==
    // originalInvoiceNumber?.trim()
    // ? "Delivered**"
    // : parcelTrackingHistory[parcel.barcode]?.[0]
    //     ?.scannedWhen !== "" &&
    //   parcelTrackingHistory[parcel.barcode]?.[0]
    //     ?.scannedWhen !== null
    // ? "Delivered"
    // : "Delivered*"
    //TODO:
    //add color logic to this
    //use it once in the for loop and destructure both variables to use
    //FIX THE STATUS FILTER to both include the new statuses and filter accurately
    //does delivered with possible exception get grouped under delivered?
    //MAKE SURE WE KNOW WHAT TO DO FOR DELIVERED** STILL //NOT ADDED TO NEW IMPLEMENTATION YET
    //ADD ALL THIS STUFF TO THE HIDDEN OVERAGES TABLE AS WELL.
    const mostRecentStop = parcelTrackingHistory[parcel.barcode]?.[0];
    const mostRecentStopWasDelivery = mostRecentStop?.stopType === 1;
    const barcodeWasScannedAtDelivery =
      mostRecentStopWasDelivery && mostRecentStop?.scannedWhen;
    const barcodeStopsWithScans = parcelTrackingHistory[parcel.barcode]?.filter(
      (trackingHistoryRow) => {
        return trackingHistoryRow.scannedWhen;
      },
    );
    // const wasScannedOntoWrongOrder =
    //   mostRecentStop.reference1?.trim() !== originalInvoiceNumber?.trim();
    // const scanAddress = {
    //   address: mostRecentStop.address,
    //   city: mostRecentStop.city,
    //   state: mostRecentStop.state,
    // };
    const actualDestinationAddress = {
      //this data comes from DMS. The customer's address
      // address: mainOrderInformation.customerAddress,
      // city: mainOrderInformation.customerCity,
      // state: mainOrderInformation.customerState,
      // zip: mainOrderInformation.customerZip,
      //We decided to change it over to data from CXT, as for returns and buyouts the destination is the client's address instead of the customer's.
      //CXT seems to give the right destination for our test orders. ex: 16287908
      address: cxtIntendedDestination.destinationAddress,
      city: cxtIntendedDestination.destinationCity,
      state: cxtIntendedDestination.destinationState,
      zip: cxtIntendedDestination.destinationZip,
    };
    const deliveryScanOnWrongOrderAtAnyPoint = parcelTrackingHistory[
      parcel.barcode
    ]?.some((trackingEntry) => {
      const trackingEntryScanAddress = {
        address: trackingEntry.address,
        city: trackingEntry.city,
        state: trackingEntry.state,
        zip: trackingEntry.zip,
      };
      return (
        trackingEntry.stopType === 1 &&
        scanWasMadeForIncorrectInvoiceAndAddress(
          {
            invoice: trackingEntry.reference1,
            location: trackingEntryScanAddress,
          },
          {
            invoice: originalInvoiceNumber,
            location: actualDestinationAddress,
          },
        )
        // trackingEntry.reference1?.trim() !== originalInvoiceNumber?.trim()
      );
    });
    // console.log(barcodeStopsWithScans);
    const barcodeHadAnyScans = barcodeStopsWithScans?.length > 0;
    // if (mostRecentStopWasDelivery) { this function should only be called if most recent stop was delivery!
    // console.log("cxt parcel table, was completed unscanned delivery stop:");
    // console.log(parcel.barcode);
    // console.log(
    //   barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoiceMap[
    //     parcel.barcode
    //   ]
    // );
    // console.log(
    //   !barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoiceMap[
    //     parcel.barcode
    //   ]
    // );
    if (
      barcodeWasScannedAtDelivery &&
      !deliveryScanOnWrongOrderAtAnyPoint
      //removing this as we don't want to show it may have been delivered to the wrong location due to the order being scanned for the wrong invoice as long as the address was correct.
      // && !barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoiceMap[
      //   parcel.barcode
      // ]
    ) {
      return {
        status: orderStatuses.delivered,
        statusColorClass: "text-success",
      };
    } else if (barcodeHadAnyScans || deliveryScanOnWrongOrderAtAnyPoint) {
      // console.log(barcodeWasScannedAtDelivery);
      // console.log(deliveryScanOnWrongOrderAtAnyPoint);
      // console.log(
      //   barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoiceMap[
      //     parcel.barcode
      //   ]
      // );
      return {
        status: orderStatuses.deliveredWithPossibleException,
        statusColorClass: "",
      };
    } else {
      return {
        status: orderStatuses.possibleException,
        statusColorClass: "",
      };
    }
    // }
  };

  return (
    <div className="table-responsive">
      <table
        // className={
        //   "table order-details-panel-table" +
        //   (cxtParcels.length > 0 ? " table-hover" : "")
        // }
        className="table order-details-panel-table"
      >
        <thead>
          <tr className="parcel-row">
            {/* <th>Parcel Id</th> */}
            <th className="order-details-table-cell order-details-parcel-table-cell-barcode">
              Barcode
            </th>
            <th className="order-details-table-cell order-details-parcel-table-cell-lastscan">
              Last Scan
            </th>
            <th className="order-details-table-cell order-details-parcel-table-cell-lastlocation">
              Last Location
            </th>
            <th className="order-details-table-cell order-details-parcel-table-cell-status">
              Status
            </th>
            <th className="order-details-table-cell order-details-parcel-table-cell-detailsbutton"></th>
          </tr>
        </thead>
        <tbody>
          {(mainBarcodes.length > 0 ? mainBarcodes : [{}]).map(
            (parcel, index) => {
              //calculateDeliveredOrderStatusDisplay should only be called if the most recent stop was a delivery stop.
              const { status, statusColorClass } =
                parcelTrackingHistory[parcel.barcode]?.[0]?.stopType === 1
                  ? calculateDeliveredOrderStatusDisplay(parcel)
                  : { status: "N/A", statusColorClass: "N/A" };
              return (
                <tr
                  key={index + "-" + (parcel.parcelId ?? "N/A")}
                  // data-parcel-id={parcel.parcelId}
                  // data-barcode={parcel.barcode}
                  // onClick={handleParcelRowClick}
                  className={
                    "parcel-row" +
                    (parcel.barcode === selectedParcel ? " table-active" : "")
                  }
                >
                  {/* <td>{parcel.parcelId ? parcel.parcelId : "N/A"}</td> */}
                  <td className="order-details-table-cell order-details-parcel-table-cell-barcode">
                    {parcel.barcode ? parcel.barcode : "N/A"}
                  </td>

                  <td className="order-details-table-cell order-details-parcel-table-cell-lastscan">
                    {parcelTrackingHistory[parcel.barcode]?.[0]?.scannedWhen
                      ? parcelTrackingHistory[parcel.barcode][0].scannedWhen +
                        " CST"
                      : "N/A"}
                  </td>
                  <td className="order-details-table-cell order-details-parcel-table-cell-lastlocation">
                    {displayCityAndState(
                      parcelTrackingHistory[parcel.barcode]?.[0]?.city,
                      parcelTrackingHistory[parcel.barcode]?.[0]?.state,
                    )}
                  </td>
                  <td
                    className={
                      "order-details-table-cell order-details-parcel-table-cell-status " +
                      (parcelTrackingHistory[parcel.barcode]?.[0]?.stopType ===
                      1
                        ? statusColorClass
                        : parcelTrackingHistory[parcel.barcode]?.[0]?.name
                          ? parcelTrackingHistory[
                              parcel.barcode
                            ]?.[0]?.name?.toLowerCase() === "not scanned"
                            ? "text-danger"
                            : parcelTrackingHistory[parcel.barcode]?.[0]
                                  ?.stopType === 1
                              ? "text-success"
                              : "text-primary"
                          : "")
                    }
                  >
                    {parcelTrackingHistory[parcel.barcode]?.[0]?.stopType === 1
                      ? status
                      : parcelTrackingHistory[parcel.barcode]?.[0]?.stopType ===
                          0
                        ? parcelTrackingHistory[parcel.barcode]?.[0]
                            ?.contractStopID !== null
                          ? "Out for Delivery"
                          : "Picked Up"
                        : //   !parcelTrackingHistory[parcel.barcode]?.[0]?.reference1
                          //     .toLowerCase()
                          //     .includes("rt") &&
                          //   !parcelTrackingHistory[parcel.barcode]?.[0]?.reference1
                          //     .toLowerCase()
                          //     .includes("bo")
                          // ? "Out for Delivery"
                          (parcelTrackingHistory[parcel.barcode]?.[0]?.name ??
                          "N/A")}
                  </td>
                  <td className="order-details-table-cell order-details-parcel-table-cell-detailsbutton">
                    <button
                      type="button"
                      className={
                        "btn btn-primary btn-sm" +
                        (cxtParcels.length > 0 ? "" : " disabled")
                      }
                      data-parcel-id={parcel.parcelId}
                      data-barcode={parcel.barcode}
                      onClick={
                        cxtParcels.length > 0 ? handleSelectParcel : null
                      }
                    >
                      Details
                    </button>
                  </td>
                </tr>
              );
            },
          )}
        </tbody>
      </table>
      {possibleOverages.length > 0 && (
        <>
          <h5>Possible Overages</h5>
          {/* <hr /> */}
          <table
            // className={
            //   "table order-details-panel-table" +
            //   (cxtParcels.length > 0 ? " table-hover" : "")
            // }
            className="table order-details-panel-table"
          >
            <thead>
              <tr className="parcel-row">
                {/* <th>Parcel Id</th> */}
                <th className="order-details-table-cell order-details-parcel-table-cell-barcode">
                  Barcode
                </th>
                <th className="order-details-table-cell order-details-parcel-table-cell-lastscan">
                  Last Scan
                </th>
                <th className="order-details-table-cell order-details-parcel-table-cell-lastlocation">
                  Last Location
                </th>
                <th className="order-details-table-cell order-details-parcel-table-cell-status">
                  Status
                </th>
                <th className="order-details-table-cell order-details-parcel-table-cell-detailsbutton"></th>
              </tr>
            </thead>
            <tbody>
              {possibleOverages.map((parcel, index) => {
                return (
                  <tr
                    key={index + "-" + (parcel.parcelId ?? "N/A")}
                    // data-parcel-id={parcel.parcelId}
                    // data-barcode={parcel.barcode}
                    // onClick={handleParcelRowClick}
                    className={
                      "parcel-row" +
                      (parcel.barcode === selectedParcel ? " table-active" : "")
                    }
                  >
                    {/* <td>{parcel.parcelId ? parcel.parcelId : "N/A"}</td> */}
                    <td className="order-details-table-cell order-details-parcel-table-cell-barcode">
                      {parcel.barcode ? parcel.barcode : "N/A"}
                    </td>

                    <td className="order-details-table-cell order-details-parcel-table-cell-lastscan">
                      {parcelTrackingHistory[parcel.barcode]?.[0]?.scannedWhen +
                      " CST"
                        ? parcelTrackingHistory[parcel.barcode][0].scannedWhen
                        : "N/A"}
                    </td>
                    <td className="order-details-table-cell order-details-parcel-table-cell-lastlocation">
                      {displayCityAndState(
                        parcelTrackingHistory[parcel.barcode]?.[0]?.city,
                        parcelTrackingHistory[parcel.barcode]?.[0]?.state,
                      )}
                    </td>
                    <td
                      className={
                        "order-details-table-cell order-details-parcel-table-cell-status " +
                        (parcelTrackingHistory[parcel.barcode]?.[0]?.name
                          ? parcelTrackingHistory[
                              parcel.barcode
                            ]?.[0]?.name?.toLowerCase() === "not scanned"
                            ? "text-danger"
                            : parcelTrackingHistory[parcel.barcode]?.[0]
                                  ?.stopType === 1
                              ? "text-success"
                              : "text-primary"
                          : "")
                      }
                    >
                      {parcelTrackingHistory[parcel.barcode]?.[0]?.stopType ===
                      1
                        ? parcelTrackingHistory[parcel.barcode]?.[0]
                            ?.reference1 !== originalInvoiceNumber
                          ? "Delivered**"
                          : parcelTrackingHistory[parcel.barcode]?.[0]
                                ?.scannedWhen !== "" &&
                              parcelTrackingHistory[parcel.barcode]?.[0]
                                ?.scannedWhen !== null
                            ? "Delivered"
                            : "Delivered*"
                        : parcelTrackingHistory[parcel.barcode]?.[0]
                              ?.stopType === 0
                          ? parcelTrackingHistory[parcel.barcode]?.[0]
                              ?.contractStopID !== null
                            ? "Out for Delivery"
                            : "Picked Up"
                          : //   !parcelTrackingHistory[parcel.barcode]?.[0]?.reference1
                            //     .toLowerCase()
                            //     .includes("rt") &&
                            //   !parcelTrackingHistory[parcel.barcode]?.[0]?.reference1
                            //     .toLowerCase()
                            //     .includes("bo")
                            // ? "Out for Delivery"
                            (parcelTrackingHistory[parcel.barcode]?.[0]?.name ??
                            "N/A")}
                    </td>
                    <td className="order-details-table-cell order-details-parcel-table-cell-detailsbutton">
                      <button
                        type="button"
                        className={
                          "btn btn-primary btn-sm" +
                          (cxtParcels.length > 0 ? "" : " disabled")
                        }
                        data-parcel-id={parcel.parcelId}
                        data-barcode={parcel.barcode}
                        onClick={
                          cxtParcels.length > 0 ? handleSelectParcel : null
                        }
                      >
                        Details
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};
const CxtTrackingHistoryCard = ({
  mainOrderInformation,
  orderCreationDate,
  orderStatus,
  deliveryId,
  customerName,
  cityState,
  cxtTrackingHistory,
  cxtIntendedDestination,
  parcelTrackingHistory,
  getNotScannedStatusResults,
  cxtPodInfo,
  selectedParcel,
  mainInvoice,
  handleBackOutOfParcelTracking,
  barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoiceMap,
}) => {
  return (
    <div className="order-details-card">
      {selectedParcel ? (
        <CxtParcelTrackingHistory
          key={selectedParcel} //we don't unmount/mount this as user changes selected parcel so we pass it in as a key so that react does not cache anything over from one parcel to the next
          selectedParcel={selectedParcel}
          mainOrderInformation={mainOrderInformation}
          cxtIntendedDestination={cxtIntendedDestination}
          mainInvoice={mainInvoice}
          orderCreationDate={orderCreationDate}
          parcelTrackingHistory={parcelTrackingHistory}
          getNotScannedStatusResults={getNotScannedStatusResults}
          handleBackOutOfParcelTracking={handleBackOutOfParcelTracking}
          barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoiceMap={
            barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoiceMap
          }
        />
      ) : (
        //give SimpleFadeIn component a key if you want to switch between two things wrapped in it on the same level i.e boolean ? <SimpleFadeIn key="1">...<SimpleFadeIn> : <SimpleFadeIn key="2">...<SimpleFadeIn> or react will think the component hasn't changed and not trigger the animation.
        <SimpleFadeIn>
          <CxtOrderTrackingHistory
            orderStatus={orderStatus}
            cxtTrackingHistory={cxtTrackingHistory}
            cxtPodInfo={cxtPodInfo}
            orderCreationDate={orderCreationDate}
            deliveryId={deliveryId}
            mainInvoice={mainInvoice}
          />
        </SimpleFadeIn>
      )}
    </div>
  );
};

export const PodModal = ({
  show,
  handleCloseModal,
  podSignature,
  prependDataURI = true,
  podName,
  showPodComment = true,
  podComment,
  orderLevel, // true for order level POD in order tracking history, false for package/barcode level POD in parcel tracking history
  deliveryId,
  barcode,
  mainInvoice,
  downloadStringOverride,
}) => {
  const PODRef = useRef();
  const handleGenerateAndDownloadPOD = () => {
    if (PODRef.current === null) {
      return;
    }
    toPng(PODRef.current, { cacheBust: true })
      .then((dataUrl) => {
        const link = document.createElement("a");
        //feel like it would be easier to track with delivery id attached but w.e.
        // link.download = `${
        //   orderLevel
        //     ? "Diligent Order Level POD for order " +
        //       deliveryId +
        //       " - Signed By " +
        //       podName
        //     : "Diligent POD for Barcode " + barcode + " - Signed By " + podName
        // }.png`;
        link.download = `${
          downloadStringOverride
            ? downloadStringOverride
            : orderLevel
              ? "Diligent Order Level POD for Invoice " +
                mainInvoice +
                " - Signed By " +
                podName +
                ` (Delivery ID ${deliveryId})`
              : "Diligent POD for Invoice " +
                mainInvoice +
                " - Signed By " +
                podName +
                ` (Barcode ${barcode})`
        }.png`;
        link.href = dataUrl;
        link.click();
      })
      .catch((error) => {
        toast.error("Issue downloading POD");
      });
  };
  return (
    <Modal
      show={show}
      onHide={handleCloseModal}
      // dialogClassName="signature-modal"
    >
      <Modal.Header>
        <Modal.Title>Signature</Modal.Title>
      </Modal.Header>
      <Modal.Body
        //providing Modal.Body ref and className for downloading it as an image. Need to make background white as it is transparent to begin with. The Modal element wrapping all of this doesn't seem to take our ref and would also be the whole modal which we don't want. Just this part. Setting the ref to the div below would miss some of the padding so I went with this
        ref={PODRef}
        className="bg-white"
      >
        <div className="text-center" style={{ backgroundColor: "white" }}>
          <img
            className="pod-signature-modal-image"
            src={
              prependDataURI
                ? "data:image/svg+xml;base64," + podSignature
                : podSignature
            }
            alt="Signature"
          />
          <p>
            Signed By: {podName ? podName : "N/A"}
            {showPodComment && (
              <>
                <br />
                Comment: <br />
                {podComment ? podComment : "N/A"}
              </>
            )}
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-primary"
          onClick={handleGenerateAndDownloadPOD}
        >
          Download
        </button>
        <button className="btn btn-secondary" onClick={handleCloseModal}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

const CxtOrderTrackingHistory = ({
  orderStatus,
  orderCreationDate,
  cxtTrackingHistory,
  cxtPodInfo,
  deliveryId,
  mainInvoice,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const handleOpenModal = () => {
    setModalOpen(true);
  };
  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const hasPodInfo =
    cxtPodInfo?.podComment || cxtPodInfo?.podName || cxtPodInfo?.podSignature;

  const isMarkedAsCompleted = cxtTrackingHistory.some(
    //so in CXT they have a "POD" (Signature) for every stop the package stops at/basically every place it should be scanned. This could be when it arrives at a dock or it is scanned for routeload (which is when they put it on their truck and get ready to deliver it), but we only want to show them the delivery POD.
    (cxtTrackingHistoryRow) => {
      return cxtTrackingHistoryRow.trackingLogType === "Delivered";
    },
  );
  return (
    <>
      <PodModal
        show={modalOpen}
        handleCloseModal={handleCloseModal}
        podSignature={cxtPodInfo?.podSignature}
        podName={cxtPodInfo?.podName}
        podComment={cxtPodInfo?.podComment}
        orderLevel={true} // true for order level POD in order tracking history, false for package/barcode level POD in parcel tracking history
        deliveryId={deliveryId}
        mainInvoice={mainInvoice}
      />
      {/* <Modal
        show={modalOpen}
        onHide={handleCloseModal}
        // dialogClassName="signature-modal"
      >
        <Modal.Header>
          <Modal.Title>Signature</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <img
              className="pod-signature-modal-image"
              src={"data:image/svg+xml;base64," + cxtPodInfo?.podSignature}
              alt="Signature"
            />
            <p>
              Signed By: {cxtPodInfo?.podName}
              <br />
              Comment: <br />
              {cxtPodInfo?.podComment}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleCloseModal}>
            Close
          </button>
        </Modal.Footer>
      </Modal> */}
      <div className="font-500 text-16">Order Tracking History</div>
      <ul
        className="order-details-card-order-history-list"
        style={{ display: "flex", flexDirection: "column" }}
      >
        {cxtTrackingHistory?.length <= 0 &&
          (orderStatus === orderStatuses.open
            ? "Not Yet Processed"
            : "Order Tracking History Not Available")}

        {/* wanted this gone for now */}
        {/* <li>
          Ordered
          <span className="float-right">
            {dateFormatWithTimeZone(
              orderCreationDate,
              "MM/dd/yyyy hh:mm a zzz"
            )}
          </span>
        </li> */}
        {cxtTrackingHistory?.map((cxtTrackingHistoryRow) => {
          return (
            <li key={cxtTrackingHistoryRow.trackingLogType}>
              {cxtTrackingHistoryRow.trackingLogType === "Ordered"
                ? "Processed"
                : cxtTrackingHistoryRow.trackingLogType === "Delivered"
                  ? "Marked as Completed"
                  : cxtTrackingHistoryRow.trackingLogType}
              <span className="float-right">
                {dateFormatWithTimeZone(
                  new Date(cxtTrackingHistoryRow.timeCompleted),
                  "MM/dd/yyyy hh:mm a zzz",
                )}
              </span>
            </li>
          );
        })}
        {/* <li>
          Ordered
          <span className="float-right">11/29/22 - 3:00 pm</span>
        </li>
        <li>
          Ordered
          <span className="float-right">11/29/22 - 3:00 pm</span>
        </li>
        <li>
          Ordered
          <span className="float-right">11/29/22 - 3:00 pm</span>
        </li>
        <li>
          Ordered
          <span className="float-right">11/29/22 - 3:00 pm</span>
        </li> */}
      </ul>
      <div className="order-details-card-pod-header text-16">
        Proof of Delivery
      </div>
      {isMarkedAsCompleted && hasPodInfo ? (
        // true/false are options for displaying =|==========>
        <div className="order-details-card-pod-content">
          <p className="pt-2">
            Signed by: {cxtPodInfo?.podName ? cxtPodInfo.podName : "N/A"} <br />
            Comment: {cxtPodInfo?.podComment
              ? cxtPodInfo.podComment
              : "N/A"}{" "}
            <br />
            Signature:
          </p>
          {cxtPodInfo?.podSignature ? (
            <div
              onClick={handleOpenModal}
              className="order-details-card-pod-signature-container"
            >
              <img
                className="order-details-card-pod-signature-image"
                src={"data:image/svg+xml;base64," + cxtPodInfo?.podSignature}
                alt="Signature"
              />
              <BsZoomIn className="pod-signature-zoom-icon" />
            </div>
          ) : (
            <div>No Signature</div>
          )}
        </div>
      ) : (
        <div className="text-note-faint">
          {statusFilterMap.delivered.includes(orderStatus) ||
          statusFilterMap.partialDelivery.includes(orderStatus)
            ? "Not Available"
            : "Not Yet Delivered"}
        </div>
      )}
    </>
  );
};
const CxtParcelTrackingHistory = ({
  selectedParcel,
  mainOrderInformation,
  parcelTrackingHistory, //sorted desc by scan date and then parcel id in origin component
  getNotScannedStatusResults, //primary source of scans now, parcel tracking history is just to get data needed to retrieve parcel images
  // orderCreationDate,
  handleBackOutOfParcelTracking,
  mainInvoice,
  orderInformation,
  cxtIntendedDestination,
  barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoiceMap,
}) => {
  // const [isLoading, setLoading] = useState(true);
  // const [parcelTrackingHistory, setParcelTrackingHistory] = useState([]);
  // useEffect(() => {
  //   const fetchParcelTracking = async () => {
  //     try {
  //       setLoading(true);
  //       console.log(orderCreationDate);
  //       const parcelTrackingHistoryResponse = await getParcelTracking(
  //         `\"${selectedParcel}\"`,
  //         orderCreationDate
  //       );
  //       console.log(parcelTrackingHistoryResponse);
  //       setLoading(false);
  //     } catch (ex) {
  //       setLoading(false);
  //       handleApiError(ex);
  //     }
  //   };
  //   fetchParcelTracking();
  //   // setTimeout(() => {
  //   //   setLoading(false);
  //   // }, 1500);
  // }, [selectedParcel]);

  // const placeholderParcelTrackingHistory = [
  //   {
  //     date: "12/19/2022 10:50 A.M.",
  //     location: "Dallas, TX",
  //     activity: "Dock Unload",
  //   },
  //   {
  //     date: "12/19/2022 3:00 P.M.",
  //     location: "Dallas, TX",
  //     activity: "Dock Departure",
  //   },
  //   {
  //     date: "12/20/2022 5:00 P.M.",
  //     location: "Dallas, TX",
  //     activity: "Delivered",
  //   },
  // ];

  // console.log(parcelTrackingHistory);
  // console.log(getNotScannedStatusResults);

  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [
    finishedTrackingHistoryForParcel,
    setFinishedTrackingHistoryForParcel,
  ] = useState([]);
  const [issueDescriptions, setIssueDescriptions] = useState([]);
  const [
    hasIncorrectLocationDeliveryScan,
    setHasIncorrectLocationDeliveryScan,
  ] = useState(false);
  const [images, setImages] = useState(); //[{}]
  const imageIds = useMemo(() => {
    return images?.map((imageData) => imageData.id);
  }, [images]);
  // console.log("details panel image ids", imageIds);
  const [parcelPodInfo, setParcelPodInfo] = useState(); // {podName, podSignature}
  // const [imageURLToFetch, setImageURLToFetch] = useState();
  const [selectedImage, setSelectedImage] = useState();

  const [parcelImageModalOpen, setParcelImageModalOpen] = useState(false);
  const [podModalOpen, setPodModalOpen] = useState(false);
  const handleParcelImageClick = async (e) => {
    // console.log(e.currentTarget);
    // setImageURLToFetch(
    //   `https://03260.xdhosted.com/CxtWebService/CXTWCF.svc/v2/Files/${e.currentTarget.dataset.imageId}`
    // );
    setSelectedImage(parseInt(e.currentTarget.dataset.imageId));
    setParcelImageModalOpen(true);
  };
  const handleCloseParcelImage = () => {
    setParcelImageModalOpen(false);
    // setImageURLToFetch();
    setSelectedImage();
  };
  const handleOpenPodModal = () => {
    setPodModalOpen(true);
  };
  const handleClosePodModal = () => {
    setPodModalOpen(false);
  };

  useEffect(() => {
    // to prevent react from trying to update state on an unmounted component after a network request returns, we are using this technique:
    //question: https://stackoverflow.com/questions/53949393/cant-perform-a-react-state-update-on-an-unmounted-component
    //answer: https://stackoverflow.com/a/60907638/12156650
    let isMounted = true; //declare mounted variable that will be turned to false on component umount.
    const fetchAdditionalParcelTrackingHistory = async () => {
      setIsLoading(true);
      let processedParcelTrackingHistory = parcelTrackingHistory[
        selectedParcel
      ]?.filter((scan) => {
        return scan.scanStatus !== "Not Scanned";
      });

      // console.log(
      //   "processedParcelTrackingHistory",
      //   processedParcelTrackingHistory,
      // );
      if (
        processedParcelTrackingHistory?.length > 0 &&
        processedParcelTrackingHistory[0]?.scanStatus === "Delivered"
      ) {
        try {
          const additionalParcelTrackingHistoryResponse =
            await getAdditionalParcelTracking(
              processedParcelTrackingHistory[0]?.id,
              isClient(),
            );
          //only run code after network request returns a response if we are still mounted
          if (isMounted) {
            const additionalParcelTrackingHistoryData =
              additionalParcelTrackingHistoryResponse.data;
            // console.log(additionalParcelTrackingHistoryData);
            //if there is any pod info - we now get POD info from getNotScannedStatus
            // if (additionalParcelTrackingHistoryData) {
            //   setParcelPodInfo({
            //     pod: additionalParcelTrackingHistoryData.pod,
            //     signature: additionalParcelTrackingHistoryData.signature,
            //   });
            // }
            //if there are any image attachments.
            const podImages = filterPODImages(
              additionalParcelTrackingHistoryData?.attachments,
              true,
            );
            if (podImages?.length > 0) {
              setImages(podImages);
            }
            //if we get any additional tracking history scans (in tracking details object), grab the exception description from the most recent scan (always seems to be element 0 but may need to look through array for the latest if it turns out this is not the case.) Or should we be displayed all exceptions on the order?
            if (
              additionalParcelTrackingHistoryData?.trackingDetails?.length > 0
            ) {
              if (
                additionalParcelTrackingHistoryData?.trackingDetails?.[0]
                  ?.exceptionDescription
              ) {
                setIssueDescriptions((prev) => [
                  ...prev,
                  additionalParcelTrackingHistoryData?.trackingDetails?.[0]
                    .exceptionDescription,
                ]);
              }
            }

            //We only display the getnotscannedstatusresults now, so this is no longer needed.
            //We still need to fetch the additionalParcelTrackingHistoryData above to get the shipment images and possibly the CXT exception description.
            //However, when we are displaying the scan history we show the getNotScannedStatusResults and not the history we get from those two sources.
            // if (
            //   additionalParcelTrackingHistoryData?.trackingDetails?.length > 1
            // ) {
            //   //as the parcel we use to search always seems to be included, we are checking to see if there is anything in addition to that
            //   //the parcel we used to search always seems to be included as index 0, so we can add everything else to the array
            //   for (
            //     let i = 1;
            //     i < additionalParcelTrackingHistoryData.trackingDetails.length;
            //     i++
            //   ) {
            //     // console.log("added additional tracking history entry");
            //     processedParcelTrackingHistory.push({
            //       address:
            //         additionalParcelTrackingHistoryData.trackingDetails[i]
            //           .address,
            //       lastScannedWhen:
            //         additionalParcelTrackingHistoryData.trackingDetails[i]
            //           .scanTime,
            //       scanStatus:
            //         additionalParcelTrackingHistoryData.trackingDetails[i]
            //           .scanStatus,
            //     });
            //   }
            //   // console.log(processedParcelTrackingHistory);
            //   processedParcelTrackingHistory = processedParcelTrackingHistory
            //     ?.filter((scan) => {
            //       return scan.scanStatus !== "Not Scanned"; //Filtering again, as additional parcel tracking endpoint can also give us not scanned statuses which have a null lastScannedWhen object
            //     })
            //     ?.sort((a, b) => {
            //       return (
            //         b.lastScannedWhen.timeStamp - a.lastScannedWhen.timeStamp
            //       );
            //     });
            // }
            // setFinishedTrackingHistoryForParcel(processedParcelTrackingHistory);
            // console.log(processedParcelTrackingHistory);

            //if the latest scan is a delivery stop, lets grab its POD info and display it.
          }
        } catch (ex) {
          setIsLoading(false);
          handleApiError(ex, history);
        }
      } else {
        setFinishedTrackingHistoryForParcel([]); //need to reset to empty array if the parcel doesn't have any scans or it will keep the previous selected parcel's data. it doesn't reset automatically when switching between parcels because we don't unmount this component between switching parcels.
      }
      setIsLoading(false);
    };
    fetchAdditionalParcelTrackingHistory();

    //=======Determine issues with order=========
    let exceptions = [];
    const mostRecentStop = getNotScannedStatusResults[selectedParcel]?.[0];
    const mostRecentStopWasDelivery = mostRecentStop?.stopType === 1;
    // console.log("not scanned results: ", getNotScannedStatusResults);
    // console.log("parcelTrackngHistory: ", parcelTrackingHistory);
    let hasDeliveryScanAtIncorrectLocation = false;
    if (mostRecentStopWasDelivery) {
      const barcodeWasScannedAtDelivery =
        mostRecentStopWasDelivery &&
        mostRecentStop?.scannedWhen !== null &&
        mostRecentStop?.scannedWhen !== "";
      const barcodeStopsWithScans = getNotScannedStatusResults[
        selectedParcel
      ]?.filter((trackingHistoryRow) => {
        return trackingHistoryRow.scannedWhen;
      });
      // console.log(mostRecentStop);
      // console.log(mainOrderInformation);
      const scanAddress = {
        address: mostRecentStop.address,
        city: mostRecentStop.city,
        state: mostRecentStop.state,
        zip: mostRecentStop.zip,
      };
      const actualDestinationAddress = {
        // address: mainOrderInformation.customerAddress,
        // city: mainOrderInformation.customerCity,
        // state: mainOrderInformation.customerState,
        // zip: mainOrderInformation.customerZip,
        address: cxtIntendedDestination?.destinationAddress,
        city: cxtIntendedDestination?.destinationCity,
        state: cxtIntendedDestination?.destinationState,
        zip: cxtIntendedDestination?.destinationZip,
      };
      const wasScannedOntoWrongOrderAtDelivery =
        scanWasMadeForIncorrectInvoiceAndAddress(
          { invoice: mostRecentStop.reference1, location: scanAddress },
          { invoice: mainInvoice, location: actualDestinationAddress },
        );
      const deliveryScanOnWrongOrderAtAnyPoint = getNotScannedStatusResults[
        selectedParcel
      ]?.some((trackingEntry) => {
        const trackingEntryScanAddress = {
          address: trackingEntry.address,
          city: trackingEntry.city,
          state: trackingEntry.state,
          zip: trackingEntry.zip,
        };
        return (
          trackingEntry.stopType === 1 &&
          scanWasMadeForIncorrectInvoiceAndAddress(
            {
              invoice: trackingEntry.reference1,
              location: trackingEntryScanAddress,
            },
            { invoice: mainInvoice, location: actualDestinationAddress },
          )
        );
      });
      // console.log(wasScannedOntoWrongOrderAtDelivery);
      // console.log(deliveryScanOnWrongOrderAtAnyPoint);
      const barcodeHadAnyScans = barcodeStopsWithScans.length > 0;
      if (!barcodeWasScannedAtDelivery) {
        // console.log("Barcode not scanned on delivery");
        if (barcodeHadAnyScans) {
          exceptions.push(deliveryExceptions.hadScansButNotOnDelivery.message);
        } else {
          exceptions.push(deliveryExceptions.hasNoScans.message);
        }
      }
      if (deliveryScanOnWrongOrderAtAnyPoint) {
        if (wasScannedOntoWrongOrderAtDelivery) {
          exceptions.push(
            mostRecentStop.scannedWhen !== null &&
              mostRecentStop.scannedWhen !== ""
              ? deliveryExceptions.deliveryScanOnWrongOrder.message
              : deliveryExceptions.deliveryCompletedOnWrongOrder.message,
          );
          hasDeliveryScanAtIncorrectLocation = true;
        } else {
          exceptions.push(
            deliveryExceptions.deliveryScanPreviouslyOnWrongOrder.message,
          );
        }
      }
    }
    //Getting rid of this for now as we only want to show an error message if the scan was for the wrong invoice and the wrong location like above.
    // if (
    //   barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoiceMap[
    //     selectedParcel
    //   ]
    // ) {
    //   exceptions.push(
    // deliveryExceptions.deliveryCompletedPreviouslyOnWrongOrder.message;
    //   );
    // }
    setIssueDescriptions((prev) => [...prev, ...exceptions]);
    setHasIncorrectLocationDeliveryScan(hasDeliveryScanAtIncorrectLocation);

    if (getNotScannedStatusResults?.[selectedParcel]?.[0]?.stopType === 1) {
      setParcelPodInfo({
        pod: getNotScannedStatusResults[selectedParcel][0].pod,
        signature:
          getNotScannedStatusResults[selectedParcel][0].signature !== null
            ? svgStringToBase64(
                getNotScannedStatusResults[selectedParcel][0].signature,
              )
            : null,
      });
    }

    return () => {
      isMounted = false;
    };
  }, [parcelTrackingHistory, selectedParcel, history]);

  // const processedTrackingHistoryForSelectedParcel = useMemo(() => {
  //   return parcelTrackingHistory[selectedParcel]?.filter((scan) => {
  //     return scan.scanStatus != "Not Scanned";
  //   });
  // }, [parcelTrackingHistory, selectedParcel]);

  // console.log("Processed tracking history for selected parcel ALGOAGOAG");
  // console.log(processedTrackingHistoryForSelectedParcel);
  // console.log("HELLLLP");
  // console.log(parcelTrackingHistory);
  // console.log(finishedTrackingHistoryForParcel);
  return isLoading ? (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  ) : (
    <>
      <PodModal
        show={podModalOpen}
        handleCloseModal={handleClosePodModal}
        showPodComment={false}
        podName={parcelPodInfo?.pod}
        podSignature={parcelPodInfo?.signature}
        orderLevel={false} // true for order level POD in order tracking history, false for package/barcode level POD in parcel tracking history
        barcode={selectedParcel}
        mainInvoice={mainInvoice}
      />
      <FullPageParcelImageModal
        show={parcelImageModalOpen}
        handleCloseModal={handleCloseParcelImage}
        // imageURLToFetch={imageURLToFetch}
        selectedImage={selectedImage}
        imageIDArray={imageIds}
        barcode={selectedParcel}
        caption={() => {
          return <div>Parcel Image</div>;
        }}
      />
      <SimpleFadeIn key={selectedParcel}>
        {/* {console.log(selectedParcel)} */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <button
            className="btn mr-2 p-0"
            onClick={handleBackOutOfParcelTracking}
          >
            <BsChevronLeft /> Back
          </button>
          <span className="font-500 text-16">Parcel Tracking History</span>
        </div>
        <div>
          <div className="parcel-tracking-barcode-display font-500">
            Barcode {selectedParcel}
          </div>
          {issueDescriptions.length > 0 && (
            <div className="pb-3">
              <div className="font-500 border-bottom mb-2">Notes</div>
              {issueDescriptions.map((issueDescription, index) => {
                return (
                  <div key={index}>
                    <span className="font-500 text-">{issueDescription}</span>
                    <BsExclamationTriangleFill
                      className="text-warning ml-1"
                      style={{ marginBottom: "5px" }}
                    />
                  </div>
                );
              })}
              {hasIncorrectLocationDeliveryScan && (
                <div className="row my-3">
                  <div className="col-lg-6 pr-lg-1">
                    <div className="barcode-notes-address-comparison-container">
                      <h6>Intended Destination</h6>
                      <div>{mainOrderInformation.customerAddress}</div>
                      <div>
                        {mainOrderInformation.customerCity},{" "}
                        {mainOrderInformation.customerState}{" "}
                        {mainOrderInformation.customerZip}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 pl-lg-1">
                    <div className="barcode-notes-address-comparison-container">
                      <h6>Scan Location</h6>
                      <div>
                        {
                          getNotScannedStatusResults[selectedParcel]?.[0]
                            ?.address
                        }
                      </div>
                      <div>
                        {getNotScannedStatusResults[selectedParcel]?.[0]?.city},{" "}
                        {getNotScannedStatusResults[selectedParcel]?.[0]?.state}
                        {getNotScannedStatusResults[selectedParcel]?.[0]?.zip}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {images && (
            <div className="pb-3">
              <div className="font-500 border-bottom mb-2">Images</div>
              <ul className="order-details-card-order-history-list p-0">
                {images.map((image) => {
                  return (
                    <button
                      key={image.id}
                      className="parcel-tracking-image-button px-3"
                      data-image-id={image.id}
                      onClick={handleParcelImageClick}
                    >
                      <li>{image.fileName + " - " + image.description}</li>
                    </button>
                  );
                })}
              </ul>
            </div>
          )}
          {(parcelPodInfo?.pod || parcelPodInfo?.signature) && (
            <div className="pb-3">
              <div className="font-500 border-bottom mb-2">
                Proof of Delivery
              </div>
              <div className="order-details-card-pod-content">
                <p className="pt-2">
                  Signed By: {parcelPodInfo?.pod ?? "N/A"} <br />
                  Signature:
                </p>
                {parcelPodInfo?.signature ? (
                  <div
                    onClick={handleOpenPodModal}
                    className="order-details-card-pod-signature-container"
                  >
                    <img
                      className="order-details-card-pod-signature-image"
                      src={
                        "data:image/svg+xml;base64," + parcelPodInfo?.signature
                      }
                      alt="Signature"
                    />
                    <BsZoomIn className="pod-signature-zoom-icon" />
                  </div>
                ) : (
                  <div>No Signature</div>
                )}
              </div>
            </div>
          )}
          <div>
            <span className="font-500">History</span>
            <table className="table">
              <thead>
                <tr>
                  {/* <th>Parcel Id</th> */}
                  {/* <th>Scan ID</th>
                  <th>Stop Type</th>
                  <th>Contract Stop ID</th>
                  <th>Completed</th> */}
                  <th>Scan Date</th>
                  <th>Location</th>
                  <th>Activity</th>
                </tr>
              </thead>
              <tbody>
                {(getNotScannedStatusResults[selectedParcel]?.length > 0
                  ? getNotScannedStatusResults[selectedParcel]
                  : [{}]
                ).map((scan, index) => {
                  return (
                    <tr
                      key={index + "-" + scan.activity}
                      className={
                        "font-small" +
                        (index === 0 //since it is sorted by date/time desc
                          ? // processedTrackingHistoryForSelectedParcel.length - 1
                            " font-500"
                          : "")
                      }
                    >
                      {/* <td>{scan.pkid}</td>
                      <td>{scan.stopType}</td>
                      <td>{scan.contractStopID}</td>
                      <td>{scan.completedTime}</td> */}
                      {/* <td>{scan.id}</td> */}
                      <td>
                        {scan.hasOwnProperty("scannedWhen")
                          ? scan.scannedWhen
                            ? `${format(
                                Date.parse(scan.scannedWhen),
                                "MM/dd/yyyy h:mma",
                              )} CST`
                            : "Not Scanned"
                          : "N/A"}
                      </td>
                      <td>{displayCityAndState(scan.city, scan.state)}</td>
                      <td style={{ wordBreak: "break-word" }}>
                        {/* if both are null/undefined return just return N/A, otherwise show what we can  */}
                        {!scan.name || scan.name === "" ? (
                          "N/A"
                        ) : (
                          // <>
                          //   {scan.address?.name?.includes("Route Load")
                          //     ? "Out for Delivery"
                          //     : scan.scanStatus ?? ""}
                          //   <br />
                          //   {scan.address?.name ?? ""}
                          // </>
                          <>
                            {scan.stopType === 1 ? (
                              <>
                                Delivered
                                <br />
                                {scan.name}
                              </>
                            ) : scan.stopType === 0 ? (
                              scan.contractStopID !== null ? (
                                <>
                                  Out for Delivery
                                  <br />
                                  {scan.name}
                                </>
                              ) : (
                                <>
                                  Picked Up
                                  <br />
                                  {scan.name}
                                </>
                              )
                            ) : (
                              scan.name
                            )}
                          </>
                        )}
                        {/* {(scan.scanStatus ?? "") +
                        " - " +
                        (scan.address?.name ?? "N/A")} */}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </SimpleFadeIn>
    </>
  );
  // return isLoading ? (
  //   <div
  //     // style={{ display: "grid", placeItems: "center", height: "100%" }} //height won't work because parent div isn't fixed height
  //     style={{
  //       position: "absolute",
  //       top: "50%",
  //       left: "50%",
  //       transform: "translate(-50%, -50%)",
  //     }}
  //   >
  //     <div className="spinner-border" role="status">
  //       <span className="sr-only">Loading...</span>
  //     </div>
  //   </div>
  // ) : (
  //   <SimpleFadeIn>
  //     <div style={{ display: "flex", alignItems: "center" }}>
  //       <button
  //         className="btn mr-2 p-0"
  //         onClick={handleBackOutOfParcelTracking}
  //       >
  //         <BsChevronLeft /> Back
  //       </button>
  //       <span className="font-500 font-16">Parcel Tracking History</span>
  //     </div>
  //     <div>
  //       <div className="parcel-tracking-barcode-display font-500">
  //         Barcode {selectedParcel}
  //       </div>
  //       <div>
  //         <table className="table">
  //           <thead>
  //             <tr>
  //               <th>Date</th>
  //               <th>Location</th>
  //               <th>Activity</th>
  //             </tr>
  //           </thead>
  //           <tbody>
  //             {placeholderParcelTrackingHistory.map((scan, index) => {
  //               return (
  //                 <tr
  //                   key={index + "-" + scan.activity}
  //                   className={
  //                     "font-small" +
  //                     (index === placeholderParcelTrackingHistory.length - 1
  //                       ? " font-500"
  //                       : "")
  //                   }
  //                 >
  //                   <td>{scan.date}</td>
  //                   <td>{scan.location}</td>
  //                   <td>{scan.activity}</td>
  //                 </tr>
  //               );
  //             })}
  //           </tbody>
  //         </table>
  //       </div>
  //     </div>
  //   </SimpleFadeIn>
  // );
};

const CommentsTab = ({ deliveryId, comments }) => {
  // const [comments, setComments] = useState();
  // const history = useHistory();
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const commentsResponse = await getOrderComments(deliveryId);
  //       console.log(commentsResponse);
  //       setComments(commentsResponse.data);
  //     } catch (ex) {
  //       handleApiError(ex, history);
  //     }
  //   };
  //   fetchData();
  // }, []);

  return (
    <div>
      <h5>Comments</h5>
      <p>{comments ? comments : "Issue retrieving comments."}</p>
    </div>
  );
};
const CodDetails = ({ codDetails }) => {
  //   console.log(codDetails);
  return (
    <div className="table-responsive">
      <table className="table order-details-panel-table">
        <thead>
          <tr>
            <th>Check Number</th>
            <th style={{ maxWidth: "300px" }}>Description</th>

            <th>Check Type</th>
            <th>Applied Date</th>
            <th>Applied Amount</th>
          </tr>
        </thead>
        <tbody>
          {(codDetails?.codChecks?.length > 0
            ? codDetails.codChecks
            : [
                {
                  checkNumber: "N/A",
                  description: "N/A",
                  checkType: "N/A",
                  appliedDate: "N/A",
                  appliedAmount: "N/A",
                },
              ]
          ).map((codCheck) => {
            return (
              <tr key={codCheck.checkNumber}>
                <td>{codCheck.checkNumber}</td>
                <td style={{ maxWidth: "300px", wordBreak: "break-word" }}>
                  {codCheck.description}
                </td>
                <td>{codCheck.checkType}</td>
                <td>
                  {codCheck.appliedDate !== "N/A"
                    ? dateFormatWithTimeZone(
                        new Date(codCheck.appliedDate),
                        "MM/dd/yyyy hh:mm a zzz",
                      )
                    : "N/A"}
                </td>
                <td>{codCheck.appliedAmount}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {codDetails.amount && ( //hiding the totals if there is no data.
        <div
          className="p-2 mx-1 h6"
          style={{ borderTop: "1px solid gray", textAlign: "right" }}
        >
          <div>Total Amount: ${codDetails?.amount}</div>
          <div>
            Total Amount Applied: $
            {codDetails?.codChecks?.reduce((sum, row) => {
              return sum + row.appliedAmount;
            }, 0)}
          </div>
          <div>Unpaid Balance: ${codDetails?.balance}</div>
        </div>
      )}
    </div>
  );
};

const loadingStates = {
  loading: "loading",
  error: "error",
  success: "success",
  nodata: "nodata",
};
const tabs = {
  parcelTracking: "parcels",
  codDetails: "cod",
  comments: "comments",
};

//MAIN COMPONENT START
export const OrderDetailsPanelV2NewEndpoint = ({
  deliveryId,
  mainInvoiceNumber,
  mainOrderDataRaw,
  orderCreationDate,
  orderStatus,
  isCod,
  customerName,
  cityState,
}) => {
  const [orderDetailsData, setOrderDetailsData] = useState(null);
  const [parcelTrackingHistory, setParcelTrackingHistory] = useState([]);
  const [getNotScannedStatusResults, setGetNotScannedStatusResults] = useState(
    [],
  );
  const [loadingState, setLoadingState] = useState(loadingStates.loading); //starts as loading
  const [activeTab, setActiveTab] = useState(tabs.parcelTracking);
  const [fadeIn, setFadeIn] = useState(true);
  const [selectedParcel, setSelectedParcel] = useState(null);
  // console.log(mainInvoiceNumber);
  const handleSelectParcel = (e) => {
    //if the already selected parcel is clicked again, deselect it

    if (selectedParcel === e.currentTarget.dataset.barcode) {
      setSelectedParcel(null);
    } else {
      setSelectedParcel(e.currentTarget.dataset.barcode);
    }
  };
  const handleBackOutOfParcelTracking = (e) => {
    setSelectedParcel(null);
  };

  const handleChangeTab = (e) => {
    // console.log(e.target.dataset.tabName);
    setActiveTab(e.target.dataset.tabName);
    setFadeIn(false);
    // console.log(fadeIn);
  };

  // whenever fadein is changed, if it was changed to false, set it to true after a short delay to trigger fade in transition
  useEffect(() => {
    //unmounted state update prevention using technique: https://stackoverflow.com/a/60907638/12156650
    let isMounted = true;
    if (!fadeIn) {
      setTimeout(() => {
        if (isMounted) {
          setFadeIn(true);
        }
      }, 20);
      //   setFadeIn(true);
      //   console.log(fadeIn);
    }
    return () => {
      isMounted = false;
    };
  }, [fadeIn]);
  //   console.log(fadeIn);
  //   useEffect(()=>{
  //     setFadeIn(true);
  //   }, [activeTab])

  const history = useHistory();
  // console.log(deliveryId);
  // console.log(invoiceNumber); //switched
  // console.log(orderCreationDate);

  const [comments, setComments] = useState();
  useEffect(() => {
    //unmounted state update prevention using this technique: https://stackoverflow.com/a/60907638/12156650
    let isMounted = true;
    const fetchData = async () => {
      try {
        // console.log(invoiceNumber); //switched
        // console.log(orderCreationDate);
        const response = await getOrderDetails(
          deliveryId,
          mainInvoiceNumber,
          format(orderCreationDate, "yyyy-MM-dd"),
          isClient(),
        );
        const commentsResponse = await getOrderComments(deliveryId, isClient());
        if (isMounted) {
          setComments(commentsResponse.data);
          // console.log(response.data);
          // console.log(typeof response.data);
          //was temp fix for backend returning string instead of error. probably safe to remove now.
          if (typeof response.data === "string") {
            // console.log("set to error");
            setLoadingState(loadingStates.error);
            // console.log(loadingState);
          } else if (response.data.length === 0) {
            //if we received a succesful response but there is no data
            setLoadingState(loadingStates.nodata);
          } else {
            //if results were received successfully
            // console.log(response.data);
            let dataToUse = response.data.filter((element) => {
              return (
                element.cxtOrderTypeName !== "Delivery" &&
                element.cxtOrderTypeName !== "Pickup" && //The Delivery type seems to usually not have the cxt tracking logs/parcel/most info, otherwise the data is usually similar, need to confirm
                element.cxtParcels?.length > 0 // sometimes we have multiple types aside from delivery that still do not have any cxt parcels, so let's filter them out
              );
            })[0];
            // dataToUse = false; //TESTING
            //added because some orders had no barcodes/pieces in cxt or deltracking. Not sure how having 0 barcodes could be possible. Need to look into this. (3/23/2023)
            //if there are no cxt parcels, set state to nodata, not sure if we want to display order level tracking if there are no barcodes. Again we may just need to fix there being orders with 0 barcodes.
            if (!dataToUse) {
              //if no object was found for dataToUse based on the above criteria, let's try to build one ourselves
              let generatedDataToUse = {};
              for (let i = 0; i < response.data.length; i++) {
                generatedDataToUse = mergeWith(
                  generatedDataToUse,
                  response.data[i],
                  //TODO: Right now we are not passing a customizer function to the mergeWith call. We simply overwrite any value with the previous unless it is null. May want to add a customizer function that, for example, only takes/overwrites cxtParcels if it has more entries/the array is longer, only takes cxttrackingLogs and cxtPODInfo if the object is of type delivery. These are just rough examples, would need to look into the data more.
                );
              }
              // console.log(generatedDataToUse);
              dataToUse = generatedDataToUse;

              if (!dataToUse) {
                //if we still didn't get anything, set to nodata state and return
                setLoadingState(loadingStates.nodata);
                return;
              }
            }
            //Making sure we get all barcodes that are returned from CXT, think we are going to switch to just getting the barcodes from deltracking. Commenting for now.
            // //now that we are sure that we did get at least some data to use, let's make sure we have all unique cxt parcels
            // for (let i = 0; i < response.data.length; i++) {
            //   //we remove duplicates later on so we do not need to do this step, this step doesn't account for there being duplicate barcodes within a single cxtParcel object either, so just removing duplicates all in one pass afterwards.
            //   // const currentUniqueBarcodes = dataToUse.cxtParcels.map(
            //   //   (parcel) => {
            //   //     return parcel.barcode;
            //   //   }
            //   // );
            //   // const newBarcodes = response.data[i].cxtParcels.filter(
            //   //   (parcel) => {
            //   //     return !currentUniqueBarcodes.includes(parcel.barcode);
            //   //   }
            //   // );
            //   dataToUse.cxtParcels = [
            //     ...dataToUse.cxtParcels,
            //     ...response.data[i].cxtParcels,
            //   ];
            //   // for (let j = 0; j < response.data[i].cxtParcels.length; j++){
            //   //   if(dataToUse.cxtParcels.)
            //   // }
            // }
            //if there are parcels, get their tracking information, but remove duplicates first
            const cxtParcelsNoDuplicates = [];
            const barcodesThatAlreadyExist = {};

            for (let i = 0; i < dataToUse.cxtParcels?.length; i++) {
              if (barcodesThatAlreadyExist[dataToUse.cxtParcels[i].barcode]) {
              } else {
                cxtParcelsNoDuplicates.push(dataToUse.cxtParcels[i]);
                barcodesThatAlreadyExist[dataToUse.cxtParcels[i].barcode] =
                  true;
              }
            }
            dataToUse.cxtParcels = cxtParcelsNoDuplicates;

            if (
              dataToUse.cxtParcels?.length > 0 &&
              dataToUse.cxtParcels[0].barcode !== "N/A"
            ) {
              // console.warn(dataToUse.cxtParcels);
              dataToUse.cxtParcels = dataToUse.cxtParcels.sort((a, b) => {
                return a.barcode - b.barcode;
              });
              // console.warn(dataToUse.cxtParcels);
              let parcelBarcodesString = "";
              //the endpoint expects a comma delimited string of barcodes with each barcode being wrapped in quotation marks ""
              // const parcelTrackingResponse = await getParcelTracking(dataToUse.cxtParcels?.reduce() // can probably use reduce but for loop easier to understand
              for (let i = 0; i < dataToUse.cxtParcels.length; i++) {
                parcelBarcodesString +=
                  '"' + dataToUse.cxtParcels[i].barcode + '",';
              }
              // console.log(parcelBarcodesString);
              const parcelTrackingHistoryResponse = await getParcelTracking(
                parcelBarcodesString,
                orderCreationDate,
                isClient(),
              );
              const notScannedStatusResponse = await getNotScannedStatus(
                dataToUse.cxtParcels.map((cxtParcel) => cxtParcel.barcode),
                isClient(),
              );
              // console.log(
              //   "old parcel tracking: ",
              //   parcelTrackingHistoryResponse.data.parcelSummaries
              // );
              // console.log(
              //   "new not scanned status: ",
              //   notScannedStatusResponse.data.results
              // );

              const notScannedStatusData =
                notScannedStatusResponse.data?.results[0] ?? []; //one time I received a null for a barcode that normally gave me an array? delivery id: 12314570, barcode: 1231457001, client TBC19984, creation date 12/21/2022, but probably can happen with any, maybe only ones that say not scanned?
              const notScannedStatusFilteredData = notScannedStatusData.filter(
                (scan) => {
                  if (
                    //ignore scan history results that have neither completion time or scanned time.
                    (scan.scannedWhen === null || scan.scannedWhen === "") &&
                    (scan.completedTime === null || scan.completedTime === "")
                  ) {
                    return false;
                  } else if (scan.stopType === 5 || scan.stopType === 0) {
                    if (scan.stopType === 0 && scan.contractStopID === null) {
                      return true; //if it is a pickup for a bo/return keep it.
                    }
                    //ignore scan history results that are stop type 5 (in between/warehouse scans) or 0 (0 is a "route load" which basically means it's out for delivery, but it can also be a pickup for a return (if stopType=0 and a contractStopId is present it's a return pickup)) if they do not have a scannedWhen
                    //results without a scannedWhen were not actually scanned, and we don't want to show expected inbetween locations if the package was not actually scanned there.
                    if (scan.scannedWhen === null || scan.scannedWhen === "") {
                      return false;
                    }
                  }
                  //so we are left with scan history results that are either delivery stops (stop type 1) if there is at least a completed time or scanned time and for the other scan history results only if they have a scan time.
                  //(right now there are only stop types 5, 0, and 1) (I could have just filtered any stopType != 1 that has no scannedWhen)
                  return true;
                },
              );

              // console.log(parcelTrackingHistoryResponse);
              setParcelTrackingHistory(
                parcelTrackingHistoryResponse.data?.parcelSummaries ?? [], //one time I received a null for a barcode that normally gave me an array? delivery id: 12314570, barcode: 1231457001, client TBC19984, creation date 12/21/2022, but probably can happen with any, maybe only ones that say not scanned?
              );
              setGetNotScannedStatusResults(notScannedStatusFilteredData);
            }
            setOrderDetailsData(dataToUse);
            setLoadingState(loadingStates.success);
          }
        }
      } catch (ex) {
        setLoadingState(loadingStates.error);
        handleApiError(ex, history);
      }
    };
    if (orderDetailsData === null && loadingState !== loadingStates.error) {
      fetchData();
    }
    return () => {
      isMounted = false;
    };
  }, [deliveryId, mainInvoiceNumber, history]);

  const cxtIntendedDestinationObject = {
    destinationName: orderDetailsData?.destination?.name,
    destinationAddress: orderDetailsData?.destination?.address1,
    destinationAddressLine2: orderDetailsData?.destination?.address2,
    destinationCity: orderDetailsData?.destination?.city,
    destinationState: orderDetailsData?.destination?.state,
    destinationZip: orderDetailsData?.destination?.zip,
    destinationZipPlus4: orderDetailsData?.destination?.plus4,
  };

  // const processParcelTrackingHistory = useCallback(() => {

  // }, []);
  //decided to proccess it in useMemo instead, so we still keep the original data

  const processedParcelTrackingHistory = useMemo(() => {
    let parcelTrackingObjectBuilder = parcelTrackingHistory.reduce(
      (rollingObject, currentElement) => {
        // console.log("rolling object");
        // console.log(rollingObject);
        // console.log(currentElement);
        //if there is a history for the current element's barcode, grab it so we can add to it. if not, initialize it.
        const currentHistoryForBarcode =
          rollingObject[currentElement.barcode] || [];
        //add current element to history for its barcode
        currentHistoryForBarcode.push(currentElement);
        //add updated history to the grouping object and return.
        rollingObject[currentElement.barcode] = currentHistoryForBarcode;
        return rollingObject;
      },
      {},
    );

    // console.log("print keys");
    for (const property in parcelTrackingObjectBuilder) {
      // console.log(property);
      parcelTrackingObjectBuilder[property].sort((a, b) => {
        //sorting by timestamp
        //if there are nulls, keep them in the beginning
        if (
          a.lastScannedWhen === null ||
          a.lastScannedWhen.timeStamp === null
        ) {
          return 1;
        }
        if (
          b.lastScannedWhen === null ||
          b.lastScannedWhen.timeStamp === null
        ) {
          return -1;
        }
        if (a.lastScannedWhen.timeStamp === b.lastScannedWhen.timeStamp) {
          return b.id - a.id;
        }

        return b.lastScannedWhen.timeStamp - a.lastScannedWhen.timeStamp;
      });
    }
    // console.log("parcel tracking object builder");
    // console.log(parcelTrackingObjectBuilder);

    return parcelTrackingObjectBuilder;
  }, [parcelTrackingHistory]);

  const [
    barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoiceMap,
    setBarcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoiceMap,
  ] = useState({}); // this is for one of our new exception statuses. We are already correctly displaying an issue message if there was an incorrect delivery scan with a correct one afterwards, but we also want to display it if there was an incorrect delivery stop without a scan(completed only) and then a correct one afterwards.

  //build an object with each barcode as a key and that barcode's scan history as the value
  const processedGetNotScannedStatusResults = useMemo(() => {
    let parcelTrackingObjectBuilder = getNotScannedStatusResults.reduce(
      (rollingObject, currentElement) => {
        // console.log(currentElement);
        // console.log("rolling object");
        // console.log(rollingObject);
        // console.log(currentElement);
        //if there is a history for the current element's barcode, grab it so we can add to it. if not, initialize it.
        const currentHistoryForBarcode =
          rollingObject[currentElement.reference] || [];
        //add current element to history for its barcode
        currentHistoryForBarcode.push(currentElement);
        //add updated history to the grouping object and return.
        rollingObject[currentElement.reference] = currentHistoryForBarcode;
        return rollingObject;
      },
      {},
    );

    // console.log(parcelTrackingObjectBuilder);

    for (const barcode in parcelTrackingObjectBuilder) {
      // const notScannedStatusManualFilteredData = [];
      // const deliveryStopTypeAlreadyAdded = false;
      // const multipleDeliveryStopTypesWithScanTime = false;
      // for (let i = 0; i < notScannedStatusData; i++) {
      //   let currentScan = notScannedStatusData[i];
      //   //keep all Scan History results with a scannedWhen(actually scanned)
      //   if (
      //     currentScan.scannedWhen !== null &&
      //     currentScan.scannedWhen !== ""
      //   ) {
      //     notScannedStatusManualFilteredData.push(currentScan);
      //     if (currentScan.stopType === 1) {
      //       deliveryStopTypeAlreadyAdded = true; // a delivery stop with a scan has already been added. We are ok with adding multiple here, atleast if they have a scan, we just want to prevent adding a delivery with a completion time only if there is already 1 with a scan time (example: barcode 1334960101)
      //     }
      //   }
      // }

      //Sometimes we have only 1 delivery stop and it only has a completion time, we agreed we want to show this
      //but barcode 1334960101 for example has 1 delivery stop with only a completion time and another with a completion and a scan time

      let hasDeliveryStopWithScan = false;
      let hasMultipleDeliveryStopWithScan = false;
      let hasDeliveryStopCompletedWithoutScan = false;
      let completedDeliveryStopsWithoutAScan = [];
      for (let i = 0; i < parcelTrackingObjectBuilder[barcode].length; i++) {
        let currentScan = parcelTrackingObjectBuilder[barcode][i];
        if (currentScan.stopType === 1) {
          //look through delivery stops
          if (
            //if it has a scan time
            currentScan.scannedWhen !== null &&
            currentScan.scannedWhen !== ""
          ) {
            if (hasDeliveryStopWithScan) {
              hasMultipleDeliveryStopWithScan = true;
            } else {
              hasDeliveryStopWithScan = true;
            }
          } else {
            //delivery stop without a scan
            hasDeliveryStopCompletedWithoutScan = true;
            completedDeliveryStopsWithoutAScan.push(currentScan);
          }
        }
      }
      const onlyCompletedDeliveryStopWithoutScan =
        hasDeliveryStopCompletedWithoutScan && !hasDeliveryStopWithScan;

      //Previously we were filtering first and then sorting, but we need to check to see if there was an unscanned but completed delivery stop completed for the wrong invoice, before a delivery stop scanned on the right invoice, before we filter.
      // console.log(property);
      parcelTrackingObjectBuilder[barcode].sort((a, b) => {
        //if the only delivery was never scanned but manually completed, we'll just show that at the top, otherwise just sort everything by scannedWhen
        if (onlyCompletedDeliveryStopWithoutScan) {
          if (b.stopType === 1) {
            return 1;
          }
          if (a.stopType === 1) {
            return -1;
          }
        }
        //if the scanned when is equal sort by pkid.
        if (a.scannedWhen === b.scannedWhen) {
          return b.pkid - a.pkid;
        }
        //if scanned when is null keep them in the beginning. (if both a and b scannedWhens are null it will sort by pkid in the above if statement)
        if (a.scannedWhen === null || a.scannedWhen === "") {
          return 1;
        }
        if (b.scannedWhen === null || b.scannedWhen === "") {
          return -1;
        }

        // console.log(b.scannedWhen - a.scannedWhen);
        //for anything else sort by scannedWhen
        return Date.parse(b.scannedWhen) - Date.parse(a.scannedWhen);
      });

      let barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoice = {};
      //if there are delivery stops with and without scans(but completed)
      if (hasDeliveryStopWithScan && hasDeliveryStopCompletedWithoutScan) {
        //and the most recent one had a scan
        if (
          parcelTrackingObjectBuilder[barcode][0].scannedWhen !== null &&
          parcelTrackingObjectBuilder[barcode][0].scannedWhen !== ""
        ) {
          //if a completed delivery stop without a scan had the wrong invoice, set a state variable to true show it later in the issue descriptions
          if (
            completedDeliveryStopsWithoutAScan.some((row) => {
              // console.log(row.reference1);
              return row.reference1 !== mainInvoiceNumber;
            })
          ) {
            barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoice[barcode] =
              true;
          }
        }
      }
      setBarcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoiceMap(
        barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoice,
      );

      //if we have a delivery stop with a scan, let's ignore the ones with only a completion time, again example is barcode 1334960101
      if (hasDeliveryStopWithScan && hasDeliveryStopCompletedWithoutScan) {
        parcelTrackingObjectBuilder[barcode] = parcelTrackingObjectBuilder[
          barcode
        ].filter((scan) => {
          if (
            scan.stopType === 1 &&
            (scan.scannedWhen === null || scan.scannedWhen === "")
          ) {
            return false;
          }
          return true;
        });
      }
    }
    // console.log("parcel tracking object builder");
    // console.log(parcelTrackingObjectBuilder);

    return parcelTrackingObjectBuilder;
  }, [getNotScannedStatusResults, mainInvoiceNumber]);

  //   console.log(orderDetailsData);

  switch (loadingState) {
    case loadingStates.success:
      return (
        <div className="order-details-panel-container">
          <div className="order-details-panel paper-panel-always">
            <div className="order-details-main-section">
              {/* {console.log(orderDetailsData?.cxtParcels)} */}
              <ul className="nav nav-pills" style={{ marginBottom: "20px" }}>
                <li className="nav-item">
                  <button
                    type="button"
                    className={
                      "order-details-tab mr-4" +
                      (activeTab === tabs.parcelTracking
                        ? " order-details-tab-active"
                        : "")
                    }
                    role="tab"
                    data-tab-name={tabs.parcelTracking}
                    onClick={handleChangeTab}
                  >
                    Parcel Tracking
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    type="button"
                    className={
                      "order-details-tab" +
                      (activeTab === tabs.comments
                        ? " order-details-tab-active"
                        : "")
                    }
                    role="tab"
                    data-tab-name={tabs.comments}
                    onClick={handleChangeTab}
                  >
                    Comments
                  </button>
                </li>
                {isCod === "Yes" && (
                  <li className="nav-item">
                    <button
                      type="button"
                      className={
                        "order-details-tab" +
                        (activeTab === tabs.codDetails
                          ? " order-details-tab-active"
                          : "")
                      }
                      role="tab"
                      data-tab-name={tabs.codDetails}
                      onClick={handleChangeTab}
                    >
                      COD Details
                    </button>
                  </li>
                )}
              </ul>
              <div className="tab-content">
                {activeTab === tabs.parcelTracking && (
                  <div
                    //   className={
                    //     "order-details-tab-pane" +
                    //     (activeTab === tabs.parcelTracking
                    //       ? " order-details-tab-pane-show"
                    //       : "")
                    //   }
                    className={"fade" + (fadeIn ? " show" : "")}
                  >
                    <CxtParcelTable2
                      cxtParcels={orderDetailsData?.cxtParcels ?? []}
                      parcelTrackingHistory={
                        processedGetNotScannedStatusResults ?? []
                      }
                      selectedParcel={selectedParcel}
                      handleSelectParcel={handleSelectParcel}
                      mainOrderInformation={mainOrderDataRaw}
                      cxtIntendedDestination={cxtIntendedDestinationObject}
                      deliveryId={
                        orderDetailsData?.deliveryInfo?.deliveryId ?? ""
                      }
                      originalInvoiceNumber={mainInvoiceNumber}
                      barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoiceMap={
                        barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoiceMap
                      }
                    />
                  </div>
                )}
                {activeTab === tabs.comments && (
                  <div className={"fade" + (fadeIn ? " show" : "")}>
                    <CommentsTab deliveryId={deliveryId} comments={comments} />
                  </div>
                )}
                {activeTab === tabs.codDetails && (
                  <div
                    //   className={
                    //     "order-details-tab-pane" +
                    //     (activeTab === tabs.codDetails
                    //       ? " order-details-tab-pane-show"
                    //       : "")
                    //   }
                    className={"fade" + (fadeIn ? " show" : "")}
                  >
                    <CodDetails
                      codDetails={orderDetailsData?.codDetails ?? []}
                    />
                  </div>
                )}
              </div>
            </div>
            <CxtTrackingHistoryCard
              orderCreationDate={orderCreationDate}
              orderStatus={orderStatus}
              deliveryId={deliveryId}
              mainInvoice={mainInvoiceNumber}
              mainOrderInformation={mainOrderDataRaw}
              customerName={customerName}
              cityState={cityState}
              cxtTrackingHistory={orderDetailsData?.cxtTrackingLogs ?? []}
              cxtIntendedDestination={cxtIntendedDestinationObject}
              parcelTrackingHistory={processedParcelTrackingHistory ?? []}
              getNotScannedStatusResults={
                processedGetNotScannedStatusResults ?? []
              }
              barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoiceMap={
                barcodesWithPreviouslyUnscannedDeliveryStopOnWrongInvoiceMap
              }
              cxtPodInfo={orderDetailsData?.cxtPodInfo}
              selectedParcel={selectedParcel}
              handleBackOutOfParcelTracking={handleBackOutOfParcelTracking}
            />
          </div>
        </div>
      );
    //   break;
    case loadingStates.loading:
      return (
        <div className="order-details-panel-container">
          <div className="order-details-panel-message paper-panel text-center">
            <div className="spinner-border mb-2 mt-4" role="status"></div>
            <span className="h3 d-block">Loading</span>
          </div>
        </div>
      );
    //   break;
    case loadingStates.nodata:
      return (
        // <div className="order-details-panel-container">
        //   <div className="order-details-panel-message paper-panel text-center">
        //     <span className="h5 d-block m-4">
        //       Order has not yet been processed.
        //     </span>
        //   </div>
        // </div>
        <div className="order-details-panel-container">
          <div className="order-details-panel paper-panel-always">
            <div className="order-details-main-section">
              {/* {console.log(orderDetailsData?.cxtParcels)} */}
              <ul className="nav nav-pills" style={{ marginBottom: "20px" }}>
                <li className="nav-item">
                  <button
                    type="button"
                    className={
                      "order-details-tab mr-4" +
                      (activeTab === tabs.parcelTracking
                        ? " order-details-tab-active"
                        : "")
                    }
                    role="tab"
                    data-tab-name={tabs.parcelTracking}
                    onClick={handleChangeTab}
                  >
                    Parcel Tracking
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    type="button"
                    className={
                      "order-details-tab" +
                      (activeTab === tabs.comments
                        ? " order-details-tab-active"
                        : "")
                    }
                    role="tab"
                    data-tab-name={tabs.comments}
                    onClick={handleChangeTab}
                  >
                    Comments
                  </button>
                </li>
                {isCod === "Yes" && (
                  <li className="nav-item">
                    <button
                      type="button"
                      className={
                        "order-details-tab" +
                        (activeTab === tabs.codDetails
                          ? " order-details-tab-active"
                          : "")
                      }
                      role="tab"
                      data-tab-name={tabs.codDetails}
                      onClick={handleChangeTab}
                    >
                      COD Details
                    </button>
                  </li>
                )}
              </ul>
              <div className="tab-content">
                {activeTab === tabs.parcelTracking && (
                  <div
                    //   className={
                    //     "order-details-tab-pane" +
                    //     (activeTab === tabs.parcelTracking
                    //       ? " order-details-tab-pane-show"
                    //       : "")
                    //   }
                    className={"fade" + (fadeIn ? " show" : "")}
                  >
                    {/* No data display, do not need to add props to this instance of CXTParcelTable2 */}
                    <CxtParcelTable2
                      cxtParcels={orderDetailsData?.cxtParcels ?? []}
                      parcelTrackingHistory={
                        processedGetNotScannedStatusResults ?? []
                      }
                      selectedParcel={selectedParcel}
                      handleSelectParcel={handleSelectParcel}
                    />
                  </div>
                )}
                {activeTab === tabs.codDetails && (
                  <div
                    //   className={
                    //     "order-details-tab-pane" +
                    //     (activeTab === tabs.codDetails
                    //       ? " order-details-tab-pane-show"
                    //       : "")
                    //   }
                    className={"fade" + (fadeIn ? " show" : "")}
                  >
                    <CodDetails
                      codDetails={orderDetailsData?.codDetails ?? []}
                    />
                  </div>
                )}
              </div>
            </div>
            {/* NODATA state */}
            <CxtTrackingHistoryCard
              orderCreationDate={orderCreationDate}
              orderStatus={orderStatus}
              deliveryId={deliveryId}
              mainInvoice={mainInvoiceNumber}
              customerName={customerName}
              cityState={cityState}
              cxtTrackingHistory={orderDetailsData?.cxtTrackingLogs ?? []}
              parcelTrackingHistory={processedParcelTrackingHistory ?? []}
              getNotScannedStatusResults={
                processedGetNotScannedStatusResults ?? []
              }
              cxtPodInfo={orderDetailsData?.cxtPodInfo}
              selectedParcel={selectedParcel}
              handleBackOutOfParcelTracking={handleBackOutOfParcelTracking}
            />
          </div>
        </div>
      );
    //   break;
    case loadingStates.error:
      return (
        <div className="order-details-panel-container">
          <div className="order-details-panel-message paper-panel text-center">
            <span className="h5 d-block m-4">
              There was an issue retrieving information for this order, please
              try again.
            </span>
          </div>
        </div>
      );
    //   break;
    default:
      return (
        <div className="order-details-panel-container">
          <div className="order-details-panel-message paper-panel text-center">
            <span className="h5 d-block m-4">
              Sorry, we're not quite sure what happened!
            </span>
          </div>
        </div>
      );
  }
};
